import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';

import styles from './SwiperServicePackages.scss';
import ServicePackageItem from '../ServicePackages/ServicePackageItem/ServicePackageItem';
import ModalMoreInfoPackage from '../ServicePackages/ModalMoreInfoPackage/ModalMoreInfoPackage';
import { stepperInfoActions } from '../../store/slices/stepperInfoSlice';

const SwiperServicePackages = ({ services, customPackage }) => {
    const [isModalMoreInfoPackageOpen, setIsModalMoreInfoPackageOpen] = useState(false);
    const dispatch = useDispatch();

    const handleSelectPackage = (id, name, price, services) => {
        dispatch(stepperInfoActions.setServicePackage({ id, name, price }));
    };

    // Guard against undefined/empty so the Swiper never maps over undefined.
    const safeServices = Array.isArray(services) ? services : [];

    if (safeServices.length === 0) {
        return null;
    }

    return (
        <>
            <Swiper
                // style={{overflow: 'hidden', width: '100%'}}
                pagination={{
                    dynamicBullets: true,
                    clickable: true,
                }}
                spaceBetween={30}
                slidesPerView={1.35}
                modules={[Pagination]}
                className="mySwiper"
            >
                {safeServices.map((item, index) => (
                    <SwiperSlide key={index}>
                        <ServicePackageItem
                            handleSelectPackage={handleSelectPackage}
                            setIsModalMoreInfoPackageOpen={setIsModalMoreInfoPackageOpen}
                            id={item.id}
                            price={item.price}
                            name={item.name}
                            services={item.service_list}
                            // favors={item.favors}
                        />
                    </SwiperSlide>
                ))}
            </Swiper>

            {isModalMoreInfoPackageOpen &&
                <ModalMoreInfoPackage setIsModalMoreInfoPackageOpen={setIsModalMoreInfoPackageOpen} />}
        </>
    );
};

export default SwiperServicePackages;
